module.exports = __webpack_public_path__ + "img/wiley-practice_planners_logo.6658b122.svg";